module.exports = __webpack_public_path__ + "static/media/icon-upload-cloud.83ae95d2.svg";